import React from 'react';
import { industries } from '../../data/mock';

const IndustriesSection = () => {
  return (
    <section id="industries" className="relative py-24 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#0B1F33] via-[#0F2942] to-[#0B1F33]"></div>
      
      {/* Subtle background image - Abstract tech */}
      <div className="absolute inset-0 opacity-[0.03]">
        <img 
          src="https://images.unsplash.com/photo-1518770660439-4636190af475?q=80&w=2940&auto=format&fit=crop"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>

      {/* Diagonal lines pattern */}
      <div className="absolute inset-0 opacity-[0.02]" style={{
        backgroundImage: `repeating-linear-gradient(
          -45deg,
          transparent,
          transparent 80px,
          rgba(91, 181, 197, 0.5) 80px,
          rgba(91, 181, 197, 0.5) 81px
        )`
      }}></div>

      {/* Decorative glow */}
      <div className="absolute top-1/2 right-0 w-80 h-80 bg-[#1F7A8C]/10 rounded-full blur-[120px] pointer-events-none"></div>

      <div className="container mx-auto px-6 lg:px-8 relative z-10">
        {/* Section Header */}
        <div className="flex items-center gap-4 mb-4">
          <div className="w-14 h-0.5 bg-[#5BB5C5] rounded"></div>
          <p className="text-[#E8B86D] text-xs font-medium uppercase tracking-widest">Industries</p>
        </div>
        <h2 className="text-[#5BB5C5] font-semibold text-2xl lg:text-3xl mb-4 max-w-2xl">
          Industry Experience
        </h2>
        <p className="text-[#B8C8D8] text-lg mb-12 max-w-3xl">
          <span className="text-[#E8B86D]">IJSS IT Solutions</span> has delivered <span className="text-[#5BB5C5]">SAP MDG</span> engagements across multiple 
          industry sectors. Each industry presents unique master data challenges 
          requiring specialized governance approaches.
        </p>

        {/* Industries Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {industries.map((industry) => (
            <div key={industry.id} className="service-card h-full">
              <h3 className="text-[#E8B86D] font-semibold mb-3">
                {industry.name}
              </h3>
              <p className="text-[#A8B8C8] text-sm">
                {industry.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default IndustriesSection;
